"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mergeStyles_1 = require("./mergeStyles");
/**
 * Merges a give set of styles by running mergeStyles for each unique key. Works
 * like Object.assign in that it layers them in the argument order specified, but will
 * not mutate them and will return the merged result.
 */
function mergeStyleSets() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var mergedRules = {};
    // tslint:disable-next-line:no-any
    var setStyles = {};
    args.forEach(function (arg) { return arg && Object.keys(arg).forEach(function (key) {
        if (!setStyles[key]) {
            setStyles[key] = [];
        }
        // tslint:disable-next-line:no-any
        setStyles[key].push(arg[key]);
    }); });
    Object.keys(setStyles).forEach(function (key) {
        // tslint:disable-next-line:no-any
        mergedRules[key] = mergeStyles_1.mergeStyles(setStyles[key]);
    });
    return mergedRules;
}
exports.mergeStyleSets = mergeStyleSets;
//# sourceMappingURL=mergeStyleSets.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/styling/lib/utilities/mergeStyleSets.js
// module id = 302
// module chunks = 0